import React from "react";
import PropTypes from "prop-types";
import {
    getFormattedDate,
    getFormattedTime
} from "../Helper/DateHelper";
import {getCountdownTillDate} from "../Helper/CountdownHelper";
import {formatCurrency} from "../../utils/CommonUtils";
import ReloadHelper from "../../utils/ReloadHelper";
import UrlBuilder from "../../utils/UrlBuilder";
import {getCommonTranslation} from "../../utils/TranslationHelper";
import Translations from "../../utils/Translations";
import {getLanguage} from "../Profile/ProfileLiveShow/ProfileLiveShowHelper";
import ProfileLiveShowButton from '../Profile/ProfileLiveShow/ProfileLiveShowButton';
import {getTranslation} from './CamShows';
import Flux from '../../flux/Flux';

class CamShowsItem extends React.PureComponent {
    constructor(props) {
        super(props);
        const hasStarted = getCountdownTillDate(this.props.item.start).isDone;
        const hasEnded = getCountdownTillDate(this.props.item.end).isDone;
        this.state = {
            countdown: hasStarted ? getCountdownTillDate(this.props.item.end) : getCountdownTillDate(this.props.item.start),
            hasStarted,
            hasEnded,
            title: this.props.item.title,
        };

        this.timer = null;

        this.getPrice = this.getPrice.bind(this);
        this.onClickProfile = this.onClickProfile.bind(this);
        this.onClickCamShow = this.onClickCamShow.bind(this);
        this.getShowTitle = this.getShowTitle.bind(this);
        this.getImg = this.getImg.bind(this);
        this.onClickItem = this.onClickItem.bind(this);
    }

    componentDidMount() {
        this.timer = window.setInterval(() => {
            const hasStarted = getCountdownTillDate(this.props.item.start).isDone;
            const hasEnded = getCountdownTillDate(this.props.item.end).isDone;
            const time = hasStarted ? this.props.item.end : this.props.item.start;
            this.setState({countdown: getCountdownTillDate(time), hasEnded, hasStarted});
        }, 1000);
    }

    componentWillUnmount() {
        window.clearInterval(this.timer);
    }

    getPrice() {
        const {value, currency,} = this.props.item.price;
        return formatCurrency(value, false, currency);
    }

    needCountdown() {
        return !this.state.hasEnded && !this.state.countdown.isDone && parseInt((new Date(this.props.item.start) - new Date()) / 3600000) < 10;
    }

    getCountdown() {
        const text = this.state.hasStarted ? getTranslation("show-ends-in") : getTranslation("show-starts-in");
        return `${text}: ${this.state.countdown.hours} ${getCommonTranslation("hours_short")} ${this.state.countdown.mins} ${getCommonTranslation(
                "minutes_short"
        )}`;
    }

    onClickProfile(e) {
        e.preventDefault();
        e.stopPropagation();
        ReloadHelper.reload(this.props.item.actorLink, e);
    }

    onClickCamShow(e) {
        if (typeof this.props.onClickItem === 'function') {
            return;
        }
        e.preventDefault();
        ReloadHelper.reload(UrlBuilder.buildActorProfileLiveShowUrl(this.props.item.actorName) + (this.props.item.count > 1 ? "?camsid=" + (new Date(this.props.item.start)).getTime() : ''));
    }

    getShowTitle() {
        if (this.state.title) {
            const titleTranslations = this.state.title;
            for (let i = 0; i < titleTranslations.length; i++) {
                if (titleTranslations[i].value && titleTranslations[i].language === getLanguage().toLowerCase()) {
                    return titleTranslations[i].value;
                }
            }
        }

        return Translations.get("LiveShow");
    }

    getImg(item) {
        if (item.imageUrl) {
            return item.imageUrl;
        }

        if (item.ump && item.ump.url) {
            return item.ump.url;
        }

        const filteredSedcards = item.sedcards && item.sedcards.filter(item => item.aspectRatio < 2);

        if (filteredSedcards.length > 0 && filteredSedcards[item.occurence]) {
            return filteredSedcards[item.occurence].url;
        }
        if (item.sedcard) {
            return item.sedcard.url;
        }
        return item.actorAvatar.url;
    }

    getButton() {
        const onCloseModal = () => {
            if (typeof this.props.onCloseModal === 'function') {
                this.props.onCloseModal();
            }
        };

        if (this.props.isFeatured) {
            if (this.props.item.isBought) {
                if (this.state.hasStarted || this.props.item.isFree) {
                    return <ProfileLiveShowButton isShowSite={true}
                                                  actorId={this.props.item.actorId}
                                                  data={this.props.item}
                                                  hasStarted={this.props.item.hasStarted}
                                                  isMobile={this.props.isMobile}
                                                  text={getTranslation("join")}
                                                  isFeatured={true}
                                                  onCloseModal={onCloseModal}/>;
                } else {
                    return <ProfileLiveShowButton>
                        <div className="cam-shows__item-bought"><i className="icon -icon-round-success-full"/>{getTranslation("bought")}</div>
                    </ProfileLiveShowButton>;
                }
            } else {
                return <ProfileLiveShowButton isShowSite={true}
                                              actorId={this.props.item.actorId}
                                              data={this.props.item}
                                              hasStarted={this.props.item.hasStarted}
                                              isMobile={this.props.isMobile}
                                              text={getTranslation("buy-ticket") + (Flux.Guest.isLoggedIn() ? " (" + this.getPrice() + ")" : "")}
                                              isFeatured={true}
                                              onCloseModal={onCloseModal}/>;
            }
        } else if (this.props.item.isBought) {
            if (this.state.hasStarted || this.props.item.isFree) {
                return <ProfileLiveShowButton isShowSite={true}
                                              actorId={this.props.item.actorId}
                                              data={this.props.item}
                                              hasStarted={this.props.item.hasStarted}
                                              isMobile={this.props.isMobile}
                                              text={getTranslation("join")}
                                              isFeatured={false}
                                              onCloseModal={onCloseModal}/>;
            } else {
                return <ProfileLiveShowButton>
                    <div className="cam-shows__item-bought"><i className="icon -icon-round-success-full"/>{getTranslation("bought")}</div>
                </ProfileLiveShowButton>;
            }
        } else {
            return <ProfileLiveShowButton isShowSite={true}
                                          actorId={this.props.item.actorId}
                                          data={this.props.item}
                                          hasStarted={this.props.item.hasStarted}
                                          isMobile={this.props.isMobile}
                                          text={getTranslation("buy-ticket") + (Flux.Guest.isLoggedIn() ? " (" + this.getPrice() + ")" : "")}
                                          isFeatured={false}
                                          onCloseModal={onCloseModal}/>;
        }
    }

    onClickItem(e) { // enable click on featured items to move item forward
        if (typeof this.props.onClickItem === 'function') {
            e.preventDefault();
            this.props.onClickItem(this.props.item.index);
        }
    }

    getFeaturedItem(item) {
        const image = this.getImg(item);
        return (
                <h3 className={"cam-shows__item cam-shows__item--featured cam-shows__item--featured-" + this.props.itemClass + (this.props.isModule ? " cam-shows__item--module" : "")}
                    onClick={this.onClickItem}>
                    {(this.props.isModule || item.isFree) && <div className="cam-shows__item-badge-container">
                        {item.isFree && <span className={'badge--filter'}>{getCommonTranslation("for-free").toUpperCase()}</span>}
                        {this.props.isModule && <span className={'badge--highlight'}>{getCommonTranslation("highlight")}</span>}
                    </div>}
                    <div><img loading={this.props.lazyImageLoading ? 'lazy' : 'eager'} onClick={this.onClickCamShow}
                              className={"cam-shows__item-image"} src={image} alt=""/></div>
                    <div className={"cam-shows__item-avatar-wrapper" + (item.actorOnline ? " cam-shows__item-avatar-wrapper--online" : "")}
                         onClick={this.onClickProfile}>
                        <img loading={this.props.lazyImageLoading ? 'lazy' : 'eager'} className="cam-shows__item-avatar" src={item.actorAvatar.url}
                             alt=""/>
                    </div>
                    <div className={"cam-shows__item-content  cam-shows__item-content--grid"}>
                        <div className="cam-shows__item-content__gradient"></div>
                        {this.needCountdown() && <div className="cam-shows__item-countdown">{this.getCountdown()}</div>}
                        <div className="cam-shows__item-text-wrapper">
                            <div className="cam-shows__item-name" onClick={this.onClickProfile}>{item.actorName}</div>
                            <h3 className="cam-shows__item-title" onClick={this.onClickCamShow}>{this.getShowTitle()}</h3>
                            <div className={!this.props.isModule ? 'cam-shows__item-date-container' : ''}>
                                <div className={this.props.isModule ? "cam-shows__item-date-wrapper" : ""}>
                                    <div className="cam-shows__item-date cam-shows__item-date--featured">
                                        <i className="icon -icon-calendar"></i>
                                        {getFormattedDate(item.start)}
                                    </div>
                                    <div className="cam-shows__item-time cam-shows__item-time--featured">
                                        <i className="icon -icon-round-time-line"></i>
                                        {getFormattedTime(item.start)} - {getFormattedTime(item.end)} {getCommonTranslation("oclock")}
                                    </div>
                                </div>
                                {!this.props.isModule && this.getButton()}
                            </div>
                        </div>
                    </div>
                </h3>
        );
    }

    getItem(item) {
        const image = this.getImg(item);
        return (
                <h3 className={"cam-shows__item" + (!item.isBought && !this.props.isModule ? " cam-shows__item--hover" : "") + (this.props.isModule ? " cam-shows__item--module" : "")}>
                    {item.isFree && <div className="cam-shows__item-badge-container">
                        {item.isFree && item.isBought && <span className={'badge--filter'}><i className="icon -icon-bell-full"/></span>}
                        {item.isFree && <span className={'badge--filter'}>{getCommonTranslation("for-free").toUpperCase()}</span>}
                    </div>}
                    <div><img loading={this.props.lazyImageLoading ? 'lazy' : 'eager'} onClick={this.onClickCamShow}
                              className={"cam-shows__item-image cam-shows__item-image--hover"} src={image} alt=""/></div>
                    <div className={"cam-shows__item-avatar-wrapper" + (item.actorOnline ? " cam-shows__item-avatar-wrapper--online" : "")}
                         onClick={this.onClickProfile}>
                        <img loading={this.props.lazyImageLoading ? 'lazy' : 'eager'} className="cam-shows__item-avatar" src={item.actorAvatar.url}
                             alt=""/>
                    </div>
                    <div className={"cam-shows__item-content"}>
                        <div className="cam-shows__item-content__gradient"></div>
                        {this.needCountdown() && <div className="cam-shows__item-countdown">{this.getCountdown()}</div>}
                        <div className="cam-shows__item-text-wrapper">
                            <a className="cam-shows__item-name" onClick={this.onClickProfile} href={this.props.item.actorLink}>{item.actorName}</a>
                            <a className={"h-unset-all"}
                               href={UrlBuilder.buildActorProfileLiveShowUrl(this.props.item.actorName) + (this.props.item.count > 1 ? "?camsid=" + (new Date(this.props.item.start)).getTime() : '')}>
                                <h3 className="cam-shows__item-title" onClick={this.onClickCamShow}>{this.getShowTitle()}</h3></a>
                            <div className="cam-shows__item-date-wrapper">
                                <div className="cam-shows__item-date">
                                    <i className="icon -icon-calendar"></i>
                                    {getFormattedDate(item.start)}
                                </div>
                                <div className="cam-shows__item-time">
                                    <i className="icon -icon-round-time-line"></i>
                                    {getFormattedTime(item.start)} - {getFormattedTime(item.end)} {getCommonTranslation("oclock")}
                                </div>
                            </div>
                        </div>
                        {!this.props.isModule &&
                                <div className={"cam-shows__item-price-wrapper" + (!item.isBought ? " cam-shows__item-price-wrapper--width" : "")}>
                                    {this.getButton()}
                                </div>}
                    </div>
                </h3>
        );
    }

    render() {
        return this.props.isFeatured ? this.getFeaturedItem(this.props.item) : this.getItem(this.props.item);
    }
}

CamShowsItem.propTypes = {
    item: PropTypes.shape({
        actorId: PropTypes.number,
        actorName: PropTypes.string,
        name: PropTypes.string,
        actorAvatar: PropTypes.shape({
            url: PropTypes.string,
        }),
        price: PropTypes.shape({
            value: PropTypes.number,
            currency: PropTypes.string,
            symbol: PropTypes.string,
        }),
        actorLink: PropTypes.string,
        index: PropTypes.number,
        actorOnline: PropTypes.bool,
        featured: PropTypes.bool,
        hasStarted: PropTypes.bool,
        imageUrl: PropTypes.string,
        start: PropTypes.string,
        end: PropTypes.string,
        isBought: PropTypes.bool,
        isFree: PropTypes.bool,
        canBuy: PropTypes.bool,
        bonusCode: PropTypes.string,
        occurence: PropTypes.number,
        count: PropTypes.number,
        title: PropTypes.oneOfType([PropTypes.array, PropTypes.shape({
            value: PropTypes.string,
            language: PropTypes.string,
        })]),
        ump: PropTypes.shape({
            url: PropTypes.string,
            aspectRatio: PropTypes.string,
        }),
    }),
    isFeatured: PropTypes.bool,
    isMobile: PropTypes.bool,
    itemClass: PropTypes.string,
    isModule: PropTypes.bool,
    lazyImageLoading: PropTypes.bool,
    onCloseModal: PropTypes.func,
    onClickItem: PropTypes.func
};

export default CamShowsItem;
